import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_8b435562";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_8b435562" };
/** script content **/
require("./dialog.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex8b435562%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fdialog%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_8b435562"],
    ctorType: "component",
    outputPath: "components/index8b435562/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-popup': getComponent(require("../popup/index.mpx?isComponent&outputPath=components%2Findex106ca599%2Findex")), 'cube-icon': getComponent(require("../icon/index.mpx?isComponent&outputPath=components%2Findex1d853680%2Findex")), 'mpx-image': getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image?isComponent"), { __mpxBuiltIn: true }), 'mpx-rich-text': getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-rich-text?isComponent"), { __mpxBuiltIn: true }) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
